import { useAuth } from '@frontegg/react';
import {
  AutoComplete,
  Button,
  Dropdown,
  Radio,
  Segmented,
  Select,
  Tooltip,
  Alert,
} from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FronteggContext } from '@frontegg/rest-api';

import {
  ExpandIcon,
  ManageViewsIcon,
  RecentSearchIcon,
  SearchIcon,
  TagIcon,
} from 'src/icons';
import { getFromStorage, storeInLocal } from 'src/lib/storage';
import {
  addRecentSearchAction,
  getAppointmentPractitionerAndPatients,
} from 'src/store/actions/appointment.action';
import { showToastSuccess } from 'src/utilities/toast';
import { v4 as uuidv4 } from 'uuid';
import { selectedEncounterSlice } from '../../store/slices/encounter';
import { TreeSelectDropdown } from '../baseComponents';
import { SelectHover } from '../baseComponents/SelectHover';
import { SingleSelect } from '../baseComponents/SingleSelect';
import { EncounterDateFilter } from './EncounterDateFilter';
import { ManageSearchEncounterModal } from './ManageSearchEncounter';
import './PastEncounter.scss';
import { SavedSearchEncounterModal } from './SaveSearchEncounter';
import { CalendarIcon, ListIcon } from '../../../../icons';
import { updateLegalConfirmationAction } from 'src/store/actions/legalConfirmation.action';
import {
  useFeatureEntitlements,
  usePermissionEntitlements,
} from '@frontegg/react';
import { listPractitioners } from '../../../../store/actions/practitioner.action';
import {
  getAllPractitionersNames,
  getRecentSearchAction,
} from '../../../../store/actions/appointment.action';
import {
  AudioOutlined,
  SignatureOutlined,
  PlusOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { isAllowedToCreateEncounter } from './permissions';
import { analytics } from 'src/services';
import { useIsOP } from 'src/hooks/misc';
import { useIsFreeUser } from 'src/hooks/common';
import moment from 'moment';
import { isEmpty } from 'lodash-es';
import { useSearchParams } from 'react-router-dom';
import ZoomMeetingModal from './ZoomMeetingModal';
import ZoomEncounterModal from '../baseComponents/ZoomEncounterModal';
import ZoomAlert from './ZoomAlert';
import { AxiosAmbient } from 'src/lib';

const DEFAULT_PAGE_SIZE = 10;

const searchPractitionerKey = (search, index) => {
  const uniqueKey = `${search?.practitioners
    ?.map((p) => p.practitionerId)
    .join(',')}-${search?.patient}-${search?.date}-${search?.status}-${index}`;
  return uniqueKey;
};

export const PastEncounterTopBar = ({
  storedFilter,
  setSearchFilters,
  searchFilters,
  setStartDate,
  setEndDate,
  setTopBarInputs,
  handleCreateEncounter,
  selectedEncounterDetails,
  setPageState,
  selectedPractitioner,
  setSelectedPractitioner,
  schedulepage,
  selectedDate,
  setEncounterStatus,
  setIsCustomSelected,
  startDate,
  endDate,
  setSelectedDate,
  record,
  changeEncounterStatus,
  setSavedStartDate,
  setSavedEndDate,
  selectedTab,
  recentSearchList,
  handleTabChange,
  setSelectedTab,
  handleRowClick,
  auraView,
  setAuraView,
  setIsMinimized,
  humanScribeStatus,
  isScribeSelected,
  setIsScribeSelected,
  setIsUpgradeModalVisible,
  handleUpgradeToProModal,
}) => {
  const dispatch = useDispatch();
  const isOP = useIsOP();
  const isFreeUser = useIsFreeUser();
  const {
    currentPractitioner,
    currentPractitionerEntitlements: _currentPractitionerEntitlements,
  } = useSelector((state) => state?.practitionerState);
  const {
    isMobileRecord,
    scribePractitioners,
    encounterList: _encounterList,
    totalEncounterWillBeArchived,
  } = useSelector((state) => state?.encounterState);
  const {
    practitionerListLoading,
    practitionerList,
    currentPractitionerSettings,
  } = useSelector((state) => state?.practitionerState);
  const { quota, timeQuota } = useSelector((state) => state?.quotaState);

  const { allPractitionersNames, settingsOrgValue } = useSelector(
    (state) => state?.appointmentState
  );

  const { legalConfirmation } = useSelector(
    (state) => state?.legalConfirmationState
  );

  const { createEncountersOnBehalfOf } = useSelector(
    (state) => state?.settingsState
  );
  const { practitionersAndPatients } = useSelector(
    (state) => state?.appointmentState || {}
  );

  const { isEntitled: isHumanScribeEntitled } =
    useFeatureEntitlements('custom-workflow');
  const { isEntitled: hasCreateEncountersOnBehalfOfAccess } =
    useFeatureEntitlements('create-encounters-on-behalf-of');
  const { isEntitled: zoomEncountersAccess } =
    useFeatureEntitlements('zoom-encounters');
  const { isEntitled: canCreateEncounter } =
    usePermissionEntitlements('encounter.create');
  const [isDefaultView, setDefaultPreferenceValue] = useState(true);

  const [isEncounterVisible, setIsEncounterVisible] = useState(false);
  const [renameTitleEncounter, setRenameTitleEncounter] = useState('');
  const [isMangeViewOpen, setIsMangeViewOpen] = useState(false);
  const [duplicateError, setDuplicateError] = useState(false);
  const [resetDateFilter, setResetDateFilter] = useState(false);
  const [isResetFiltersOn, setIsResetFiltersOn] = useState(false);
  const [selectedDates, setSelectedDates] = useState([null, null]);
  const [selectedFilter, setSelectedFilter] = useState(() => {
    const storedFilter = localStorage.getItem(
      `${currentPractitioner?.org_uuid}_selectedFilter`
    );
    return storedFilter == null ? 'Loading...' : storedFilter || 'Today';
  });
  const [startDateRange, setStartDateRange] = useState('');
  const [endDateRange, setEndDateRange] = useState('');
  const [getAllPractitionerNames, setAllPractitionerNames] = useState([]);
  const org_Practitioner_id = currentPractitioner?.practitioner_id;
  const [selectedPractitionerObj, setSelectedPractitionerObj] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  const [patientArray, setPatientArray] = useState([]);
  const [filteredPatientNames, setFilteredPatientNames] = useState([]);
  const [showZoomModal, setShowZoomModal] = useState(false);
  const [isBasicModalVisible, setIsBasicModalVisible] = useState(false);
  const [localPractitionerSettings, setLocalPractitionerSettings] = useState(
    currentPractitionerSettings
  );
  const [searchParams] = useSearchParams();
  const ZoomAuthCode = searchParams.get('code');
  const { user } = useAuth();

  const [showExpirationBanner, setShowExpirationBanner] = useState(true);

  const EXPIRATION_BANNER_CLOSED_TIMESTAMP_KEY = `${currentPractitioner?.org_uuid}_expirationBannerClosedTimestamp`;

  // Basic modal handlers
  const handleOpenBasicModal = () => {
    setIsBasicModalVisible(true);
  };

  const handleBasicModalOk = () => {
    console.log('Meeting ended, cleaning up Zoom SDK');

    // Track meeting ended confirmation
    analytics.track('Confirmed Zoom Meeting Ended From Zoom Alert Modal', {
      email: user?.email,
    });

    setIsBasicModalVisible(false);

    // Clean up Zoom SDK and perform hard reload when user confirms meeting has ended
    try {
      // Clean up any Zoom SDK instances
      if (window.ZoomMtg) {
        console.log('Cleaning up Zoom SDK...');
        window.ZoomMtg.destroy();
      }

      // Clear any Zoom-related global variables
      delete window.ZoomMtg;
      delete window.cleanupZoomSDK;
      delete window.leaveZoomMeeting;

      console.log('Zoom SDK cleanup completed, performing hard reload...');

      // Perform hard reload to ensure complete cleanup
      window.location.reload();
    } catch (error) {
      console.error('Error during Zoom cleanup:', error);
      window.location.reload();
    }
  };

  const handleOpenInNewTab = () => {
    // Track opening in new tab
    analytics.track('Opened Zoom Meeting in New Tab from Zoom Alert Modal', {
      email: user?.email,
    });

    window.open(window.location.href, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    const closedTimestamp = getFromStorage(
      EXPIRATION_BANNER_CLOSED_TIMESTAMP_KEY
    );
    if (closedTimestamp) {
      const twentyFourHoursInMs = 24 * 60 * 60 * 1000;
      if (Date.now() - parseInt(closedTimestamp, 10) < twentyFourHoursInMs) {
        setShowExpirationBanner(false);
      }
    }
  }, [currentPractitioner?.org_uuid, EXPIRATION_BANNER_CLOSED_TIMESTAMP_KEY]);

  const FREE_TIER_RETENTION_DAYS = 21;
  const EXPIRATION_WARNING_DAYS = 7;

  useEffect(() => {
    setStartDateRange(
      localStorage.getItem(`${currentPractitioner?.org_uuid}_startDateRange`)
    );
    setEndDateRange(
      localStorage.getItem(`${currentPractitioner?.org_uuid}_endDateRange`)
    );
  }, [currentPractitioner?.org_uuid]);

  const [selectedTitleEncounter, setSelectedTitleEncounter] = useState(null);

  useEffect(() => {
    const fetchZoomToken = async () => {
      if (ZoomAuthCode) {
        console.log('Received Authorization Code:', ZoomAuthCode);

        try {
          const headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
          };

          const requestBody = {
            code: ZoomAuthCode,
          };

          const result = await AxiosAmbient.post('/zoom-auth', requestBody, {
            headers,
          });
          const _response = result?.data;
          localStorage.setItem('ZoomAuthCode', ZoomAuthCode);

          console.log('✅ Zoom authentication completed');
        } catch (error) {
          console.log('Failed to complete encounter', error);
        }
      }
    };

    fetchZoomToken();
  }, [ZoomAuthCode]);

  useEffect(() => {
    if (!localPractitionerSettings) {
      setLocalPractitionerSettings(currentPractitionerSettings);
    }
  }, [currentPractitionerSettings]);

  const setupJoinButtonAutomation = () => {
    const clickJoinButton = () => {
      try {
        const joinButtons = Array.from(
          document.querySelectorAll('button')
        ).filter((button) => {
          return (
            button.textContent === 'Join' ||
            button.innerText === 'Join' ||
            button.textContent.includes('Join') ||
            button.id === 'joinBtn' ||
            button.getAttribute('data-id') === 'btnJoin' ||
            button.className.includes('join')
          );
        });

        if (joinButtons.length > 0) {
          console.log(
            'Found join button, clicking automatically...',
            joinButtons[0]
          );
          joinButtons[0].click();
          return true;
        }

        const blueJoinButton =
          document.querySelector('.join-btn') ||
          document.querySelector('.join-meeting-btn') ||
          document.querySelector('.zmu-btn--primary');

        if (blueJoinButton) {
          console.log(
            'Found join button by class, clicking...',
            blueJoinButton
          );
          blueJoinButton.click();
          return true;
        }

        return false;
      } catch (error) {
        console.error('Error clicking join button:', error);
        return false;
      }
    };

    const setupJoinObserver = () => {
      console.log('Setting up mutation observer for join button...');

      const observer = new MutationObserver((mutations, obs) => {
        if (clickJoinButton()) {
          console.log('Successfully clicked join button via observer');
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      window._zoomJoinObserver = observer;
    };

    if (!clickJoinButton()) {
      setupJoinObserver();

      const intervalId = setInterval(() => {
        if (clickJoinButton()) {
          console.log('Successfully clicked join button via interval');
          clearInterval(intervalId);
        }
      }, 1000);

      setTimeout(() => {
        clearInterval(intervalId);
      }, 30000);
    }
  };

  const addRecentSearch = (
    practitionerId,
    practitionerName,
    title,
    isDefaultView,
    date
  ) => {
    const newSearch = {
      practitioners: [
        {
          practitionerId: practitionerId === 'All' ? 'All' : practitionerId,
          practitionerName: practitionerName || '',
        },
      ],
      status: searchFilters?.status ? searchFilters?.status : '',
      title: title || '',
      isDefaultView: isDefaultView || false,
      date: date || '',
      id: uuidv4(),
    };
    if (recentSearchList?.search_preference?.length > 0) {
      let updatedSearches = recentSearchList?.search_preference || [];

      // If the new search has isDefaultView = true, set all existing ones with isDefaultView = true to false
      if (isDefaultView) {
        updatedSearches = updatedSearches.map((search) => {
          if (search.isDefaultView) {
            return { ...search, isDefaultView: false };
          }
          return search;
        });
      }

      // Add the new search (with isDefaultView = true or false)
      updatedSearches = [newSearch, ...updatedSearches];
      dispatch(addRecentSearchAction(updatedSearches, 'encounters'));

      showToastSuccess('View saved');
    } else {
      dispatch(addRecentSearchAction([newSearch], 'encounters'));
      showToastSuccess('View saved');
    }
  };

  const handleSaveView = () => {
    analytics.track('Clicked Submit After Adding View In Aura Custom Views', {
      title: renameTitleEncounter,
      email: user?.email,
    });
    addRecentSearch(
      selectedPractitioner,
      options.find((option) => option.value === selectedPractitioner)?.name,
      renameTitleEncounter,
      isDefaultView,
      isMobileView
        ? selectedTab && selectedTab
        : selectedFilter === 'Yesterday' ||
            selectedFilter === 'Past 7 days' ||
            selectedFilter === 'Today' ||
            selectedFilter === 'All time'
          ? selectedFilter
          : 'All time'
    );
    setIsEncounterVisible(false);
    storeInLocal(
      `${currentPractitioner?.org_uuid}_selectedTitleEncounter`,
      renameTitleEncounter
    );

    setDuplicateError(false);
  };

  const handleMangeViews = () => {
    analytics.track('Clicked Manage Views In Aura Custom Views', {
      email: user?.email,
    });
    setIsMangeViewOpen(true);
  };

  const handleSaveDuplicate = () => {
    const existingTitles =
      recentSearchList?.search_preference?.map((search) => search.title) || [];
    const isDuplicate = existingTitles.includes(renameTitleEncounter.trim());
    if (isDuplicate) {
      setDuplicateError(true);
      return;
    }
    handleSaveView();
  };

  const handleCloseManageView = () => {
    analytics.track('Clicked Cancel Button In Aura Manage Views Modal', {
      email: user?.email,
    });
    setIsMangeViewOpen(false);
  };
  const handleRecentSearchSelect = (search) => {
    setRenameTitleEncounter('');
    const practitionerIds =
      search?.practitioners?.map((p) => p.practitionerId) || [];
    setSearchFilters({
      practitioner_id: practitionerIds,
      status: search?.status,
    });
    setSelectedDate(search?.date);
    setSelectedDates([null, null]);
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_startDateRange`);
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_endDateRange`);
    setSelectedFilter(search?.date);
    setSelectedTab && setSelectedTab(search?.date);
    storeInLocal(`${currentPractitioner?.org_uuid}_selectedTab`, search?.date);

    const selectedPractitioner = search.practitioners?.length
      ? search.practitioners[0].practitionerId
      : null;
    setSelectedPractitioner(selectedPractitioner);
    changeEncounterStatus(record?.encounter_id);
    storeInLocal(
      `${currentPractitioner?.org_uuid}_storePractitioner`,
      practitionerIds
    );
    const recentSearchDateFilter =
      search?.date !== 'N/A' ? search?.date : 'All time';
    storeInLocal(
      `${currentPractitioner?.org_uuid}_selectedFilter`,
      recentSearchDateFilter
    );
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_selectedDates`);
    search?.status
      ? storeInLocal(
          `${currentPractitioner?.org_uuid}_savedStatus`,
          search?.status
        )
      : storeInLocal(`${currentPractitioner?.org_uuid}_savedStatus`, '');
    if (search?.id && search?.id?.length > 0) {
      handleRowClick(search.id[0]);
    }
  };

  const handleDateFilterChange = (value) => {
    dispatch(selectedEncounterSlice(null));
    setEncounterStatus('');

    if (Array.isArray(value) && value.length === 2) {
      const [startDate, endDate] = value;
      setPageState({
        current: 1,
        pageSize: auraView === 'LIST' ? DEFAULT_PAGE_SIZE : 100,
      });
      setStartDate(startDate);
      setEndDate(endDate);
      setIsCustomSelected(true);
      setSelectedDate('Custom…🗓️');
      storeInLocal(
        `${currentPractitioner?.org_uuid}_selectedDate`,
        'Custom…🗓️'
      );
    } else {
      setPageState({
        current: 1,
        pageSize: auraView === 'LIST' ? DEFAULT_PAGE_SIZE : 100,
      });
      setIsCustomSelected(false);
      setSelectedDate(value);
      if (startDate || endDate) {
        setStartDate(null);
        setEndDate(null);
      }
    }
  };

  useEffect(() => {
    if (!storedFilter) {
      const defaultRecord = recentSearchList?.search_preference?.find(
        (record) => record.isDefaultView === true
      );

      if (defaultRecord) {
        handleRecentSearchSelect(defaultRecord);
      }
    }
  }, []);

  useEffect(() => {
    const storedPractitioner = getFromStorage(
      `${currentPractitioner?.org_uuid}_selectedPractitioner`
    );
    const storedStatus = getFromStorage(
      `${currentPractitioner?.org_uuid}_savedStatus`
    );

    if (storedPractitioner) {
      setSelectedPractitioner(JSON.parse(storedPractitioner));
      setSearchFilters((prev) => ({
        ...prev,
        practitioner_id: JSON.parse(storedPractitioner),
        status: storedStatus,
      }));
    }
  }, []);

  const payload = {
    is_new_appointment: true,
  };

  useEffect(() => {
    dispatch(listPractitioners(searchFilters));
    dispatch(getAllPractitionersNames(payload));
    dispatch(getAppointmentPractitionerAndPatients());
    dispatch(getRecentSearchAction('encounters'));
  }, [dispatch]);

  const handleAddLabel = () => {
    analytics.track('Clicked Save This View In Aura Custom Views', {
      email: user?.email,
    });
    setIsEncounterVisible(true);
  };

  const handleCloseView = () => {
    analytics.track('Clicked Cancel In Aura Save This View Modal', {
      email: user?.email,
    });
    setIsEncounterVisible(false);
    setRenameTitleEncounter('');
  };

  const handleSetDefault = (selectedRecord) => {
    const updatedSearches = (recentSearchList?.search_preference || []).map(
      (record) => {
        if (record.id === selectedRecord.id) {
          return { ...record, isDefaultView: true };
        }

        return { ...record, isDefaultView: false };
      }
    );

    dispatch(addRecentSearchAction(updatedSearches, 'encounters'));

    showToastSuccess('Default preference updated');
  };

  useEffect(() => {
    if (selectedEncounterDetails) {
      setTopBarInputs((prevInputs) => ({
        ...prevInputs,
        description: defaultDescription,
      }));
    }
  }, [selectedEncounterDetails]);

  const defaultDescription = selectedEncounterDetails?.description || '';

  const isMobileView = window.innerWidth <= 1260;

  const getFilteredPractitioners = useMemo(() => {
    // Create a Set of practitioner_ids that have is_shown: true
    const shownPractitionerIds = new Set(
      Array.isArray(allPractitionersNames)
        ? allPractitionersNames
            .filter((practitioner) => practitioner.is_shown === true)
            .map((practitioner) => practitioner.practitioner_id)
        : []
    );

    // Add currentPractitioner if settingsOrgValue has_appointments is true or currentPractitioner?.practitioner_id is present
    if (
      settingsOrgValue?.has_appointments ||
      currentPractitioner?.practitioner_id
    ) {
      shownPractitionerIds.add(currentPractitioner?.practitioner_id);
    }

    // Filter practitionerList based on shown practitioner IDs
    return (
      practitionerList?.filter((practitioner) =>
        shownPractitionerIds.has(practitioner.practitioner_id)
      ) ||
      practitionerList ||
      []
    );
  }, [
    practitionerList,
    allPractitionersNames,
    settingsOrgValue,
    currentPractitioner,
  ]);

  const filteredPractitioners = getFilteredPractitioners;

  const options = useMemo(() => {
    if (!filteredPractitioners) return [];
    const practitionerOptions = filteredPractitioners?.map(
      (practitioner, index, array) => {
        const practitionersWithSameName = array.filter(
          (p) => p.full_name === practitioner.full_name && p !== practitioner
        );
        const displayEmail = practitionersWithSameName.length > 0;
        return {
          value: practitioner.practitioner_id,
          label: (
            <div>
              <div>{practitioner.full_name}</div>
              {displayEmail && (
                <div
                  style={{
                    color: 'grey',
                    fontSize: 'smaller',
                    fontFamily: 'Poppins',
                  }}
                >
                  {practitioner.practitioner_email}
                </div>
              )}
            </div>
          ),
          name: practitioner.full_name,
        };
      }
    );

    if (!practitionerOptions?.length) return [];

    // If settings returns an empty list (meaning all are hidden) and we only have
    // one practitioner option, don't show an "All" option.
    if (
      Array.isArray(allPractitionersNames) &&
      allPractitionersNames.length === 0 &&
      practitionerOptions.length === 1
    ) {
      return practitionerOptions;
    }

    return [
      { label: 'All', value: 'All', name: 'All' },
      ...practitionerOptions,
    ];
  }, [filteredPractitioners, allPractitionersNames]);

  const scribeOptions = useMemo(() => {
    if (!scribePractitioners) return [];

    return scribePractitioners?.map((practitioner, index, array) => {
      const practitionersWithSameName = array.filter(
        (p) =>
          p.practitioner_name === practitioner.practitioner_name &&
          p !== practitioner
      );
      const displayEmail = practitionersWithSameName.length > 0;
      return {
        value: practitioner.practitioner_id,
        label: (
          <div>
            <div>{practitioner.practitioner_name}</div>
            {displayEmail && (
              <div
                style={{
                  color: 'grey',
                  fontSize: 'smaller',
                  fontFamily: 'Poppins',
                }}
              >
                {practitioner.practitioner_email}
              </div>
            )}
          </div>
        ),
        name: practitioner.practitioner_name,
      };
    });
  }, [scribePractitioners]);

  const handleAuraCalenderTabChange = (key) => {
    if (key === 'LIST') {
      setPageState((prevState) => ({
        ...prevState,
        pageSize: DEFAULT_PAGE_SIZE,
      }));
      setIsMinimized(false);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        pageSize: 100,
      }));
      setIsMinimized(true);
    }
    setAuraView(key);
    analytics.track(`Switched Encounter View to: ${key}`, {
      email: user?.email,
    });
  };

  const statusOptions = [
    {
      title: 'All',
      value: '',
      className: 'flex justify-center items-center h-8 rounded-full',
      style: {
        background: '#ffffff',
        hoverBackground: '#f7f7f7',
      },
    },
    {
      title: 'Completed',
      value: 'completed',
      className:
        'text-[#1ec990] bg-[#eefaf4] flex items-center justify-center rounded-full hover:bg-[#A2EFC9] h-8 px-3 text-xs',
    },
    {
      title: 'In Progress',
      value: 'inprogress',
      className:
        'text-[#ff6f00] bg-[#ffe1ca] flex items-center justify-center rounded-full hover:bg-[#F7CFB1] h-8 px-3 text-xs',
    },
    {
      title: 'Not Started',
      value: 'new',
      className:
        'text-[#5a8dda] bg-[#e7f1ff] flex items-center justify-center rounded-full hover:bg-[#BCD4F7] status-options h-8 text-xs',
    },
    ...(isOP
      ? []
      : [
          {
            title: 'Saved to EHR',
            value: 'saved_to_ehr',
            className: 'h-8 flex items-center justify-center rounded-full',
            style: {
              background: '#e7e7e7',
              hoverBackground: '#D1D1D1',
              color: '#292929',
            },
          },
          {
            title: 'Copied to EHR',
            value: 'copied_to_ehr',
            className: 'h-8 flex items-center justify-center rounded-full',
            style: {
              background: '#F3F0FF',
              hoverBackground: '#E5DBFF',
              color: '#7048E8',
            },
          },
        ]),
  ];

  const humanScribeStatusOptions = [];
  if (isHumanScribeEntitled) {
    (humanScribeStatus?.aura_status_mapping || []).forEach((status) => {
      if (!status?.filterdisabled) {
        const humanScribeStatusOption = {
          title: `${status.status_name}`,
          value: status.status_id,
          className: `h-8 flex items-center justify-center rounded-full text-xs`,
          style: {},
        };
        if (status.background) {
          humanScribeStatusOption.style.background = status.background;
        }
        if (status.color) {
          humanScribeStatusOption.style.color = status.color;
        }

        if (status.hover) {
          humanScribeStatusOption.style.hoverBackground = status.hover;
        }

        humanScribeStatusOptions.push(humanScribeStatusOption);
      }
    });
  }
  useEffect(() => {
    const savedDateFilter = getFromStorage(
      `${currentPractitioner?.org_uuid}_selectedDate`
    );

    if (savedDateFilter && savedDateFilter !== 'undefined') {
      setSelectedDate(savedDateFilter);
    }
  }, []);

  useEffect(() => {
    storeInLocal(`${currentPractitioner?.org_uuid}_selectedDate`, selectedDate);
  }, [selectedDate]);

  useEffect(() => {
    if (!schedulepage) {
      setSelectedPractitioner(currentPractitioner?.practitioner_id);
    }
  }, [currentPractitioner]);

  const onChange = (value, option, type, prac_type = 'practitioners') => {
    setPageState({
      current: 1,
      pageSize: DEFAULT_PAGE_SIZE,
    });

    dispatch(selectedEncounterSlice(null));
    if (type === 'practitioner') {
      if (prac_type === 'scribes') {
        setIsScribeSelected(true);
      } else {
        setIsScribeSelected(false);
      }
      setIsResetFiltersOn(false);
      analytics.track('Selected Practitioner Filter Option In Aura', {
        email: user?.email,
      });
      value &&
        storeInLocal(
          `${currentPractitioner?.org_uuid}_storePractitioner`,
          value
        );
      changeEncounterStatus(record?.encounter_id);
      setSearchFilters((prev) => ({
        ...prev,
        practitioner_id: value || null,
      }));
      setSelectedPractitioner(value || null);
    }
  };

  const handleStatusChange = (value) => {
    setIsResetFiltersOn(false);
    analytics.track('Selected Status Filter Option In Aura', {
      email: user?.email,
    });
    dispatch(selectedEncounterSlice(null));
    if (value === 'all') {
      storeInLocal(`${currentPractitioner?.org_uuid}_savedStatus`, '');
      setSearchFilters((prevFilters) => ({
        ...prevFilters,
        status: '',
      }));
    } else {
      storeInLocal(`${currentPractitioner?.org_uuid}_savedStatus`, value);
      setSearchFilters((prevFilters) => ({
        ...prevFilters,
        status: value,
      }));
    }
    setPageState({
      current: 1,
      pageSize: DEFAULT_PAGE_SIZE,
    });
  };

  const savedPractitioner_ID = getFromStorage(
    `${currentPractitioner?.org_uuid}_storePractitioner`
  );

  useEffect(() => {
    if (currentPractitioner?.practitioner_id && savedPractitioner_ID) {
      savedPractitioner_ID !== 'All'
        ? setSelectedPractitioner(parseInt(savedPractitioner_ID))
        : setSelectedPractitioner(savedPractitioner_ID);
    }
  }, [currentPractitioner?.practitioner_id, savedPractitioner_ID]);

  //Reset functionality
  const resetFilters = () => {
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_startDateRange`);
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_endDateRange`);
    localStorage.removeItem(
      `${currentPractitioner?.org_uuid}_storePractitioner`
    );
    localStorage.removeItem(
      `${currentPractitioner?.org_uuid}_selectedTitleEncounter`
    );
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_selectedSearch`);
    localStorage.removeItem(
      `${currentPractitioner?.org_uuid}_selectedPractitioner`
    );
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_selectedTab`);
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_selectedDate`);
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_savedStatus`);
    localStorage.removeItem(`${currentPractitioner?.org_uuid}_selectedDates`);
    setSelectedTitleEncounter('');
    analytics.track('Clicked Clear Filters In Aura', { email: user?.email });
    setSavedStartDate && setSavedStartDate(null);
    setSavedEndDate && setSavedEndDate(null);
    setSearchFilters({});
    setFilteredPatientNames([]);
    setSelectedDate('Today');
    const practitionerValue = currentPractitioner?.practitioner_id || 'All';
    setSelectedPractitioner(practitionerValue);
    storeInLocal(
      `${currentPractitioner?.org_uuid}_storePractitioner`,
      practitionerValue
    );
    setStartDate(null);
    setEndDate(null);
    setRenameTitleEncounter('');
    setSelectedTab && setSelectedTab('Today');
    setResetDateFilter(true);
    setSelectedFilter('');
    setIsResetFiltersOn(true);
  };

  const loggedInUserName = currentPractitioner?.practitioner_name;
  const [loggedInSelectedPractitioner, setloggedInSelectedPractitioner] =
    useState(null);

  useEffect(() => {
    setloggedInSelectedPractitioner(loggedInUserName);
  }, [loggedInUserName]);

  const storeSavedTabMobile = getFromStorage(
    `${currentPractitioner?.org_uuid}_selectedTab`
  );
  const [currentDate, setCurrentDate] = useState(new Date());

  const isCreateEncounterAllowed = useMemo(() => {
    return isAllowedToCreateEncounter({
      remainingEncounters: quota?.encounters?.remaining,
      remainingDays: timeQuota?.remaining_days,
      canCreateEncounter,
    });
  }, [
    quota?.encounters?.remaining,
    timeQuota?.remaining_days,
    canCreateEncounter,
  ]);

  const createEncounterTooltipText = useMemo(() => {
    if (
      quota?.encounters?.remaining !== null &&
      quota?.encounters?.remaining <= 0
    ) {
      return 'You have exhausted the monthly quota.';
    }
    if (timeQuota?.remaining_days !== null && timeQuota?.remaining_days <= 0) {
      return 'Your free trial has expired.';
    }
    if (!canCreateEncounter) {
      return "You don't have access to create encounters";
    }
    return '';
  }, [
    quota?.encounters?.remaining,
    timeQuota?.remaining_days,
    canCreateEncounter,
  ]);

  const renderCalendar = (date, onSelectDateRange, selectedDates) => {
    const daysInMonth = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDate();
    const firstDayOfMonth = new Date(
      date.getFullYear(),
      date.getMonth(),
      1
    ).getDay();
    const today = new Date();

    const dates = [];
    let startSelection = selectedDates[0] ? new Date(selectedDates[0]) : null;
    let endSelection = selectedDates[1] ? new Date(selectedDates[1]) : null;

    const selectDate = (currentDate) => {
      setIsResetFiltersOn(false);
      if (!startSelection || (startSelection && endSelection)) {
        startSelection = currentDate;
        endSelection = null;
      } else {
        endSelection = currentDate;
      }
      if (startSelection && endSelection) {
        analytics.track('Clicked Date Filter In Aura', { email: user?.email });
      }
      onSelectDateRange(startSelection, endSelection);
    };

    for (let i = 1; i <= daysInMonth; i++) {
      const currentDate = new Date(date.getFullYear(), date.getMonth(), i);
      let className = 'calendar-day';

      if (startSelection && endSelection) {
        if (currentDate.getTime() === startSelection.getTime()) {
          className += ' selected-start';
        } else if (currentDate.getTime() === endSelection.getTime()) {
          className += ' selected-end';
        } else if (currentDate > startSelection && currentDate < endSelection) {
          className += ' selected-middle';
        }
      } else if (
        startSelection &&
        currentDate.getTime() === startSelection.getTime()
      ) {
        className += ' selected-start';
      }

      if (currentDate.toDateString() === today.toDateString()) {
        className += ' current-date';
      }

      if (startSelection && !endSelection && currentDate < startSelection) {
        className += ' disabled';
      }

      if (endSelection) {
        className = className.replace('disabled', '');
      }

      dates.push(
        <div
          key={currentDate}
          className={className}
          onClick={() => selectDate(currentDate)}
        >
          {i}
        </div>
      );
    }

    // Empty divs to fill up the grid until the first day of the month
    for (let i = 0; firstDayOfMonth > 0 && i < firstDayOfMonth; i++) {
      dates.unshift(
        <div key={`empty-${i}`} className="calendar-day empty"></div>
      );
    }

    return (
      <div className="calendar">
        <div className="calendar-grid">
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
            <div className="calendar-day-name" key={day}>
              {day}
            </div>
          ))}
          {dates}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (allPractitionersNames && Array.isArray(allPractitionersNames)) {
      let dataArr = [];
      const filteredPractitioners = allPractitionersNames.filter(
        (practitioner) => practitioner.is_shown === true
      );

      if (
        settingsOrgValue?.has_appointments ||
        currentPractitioner?.practitioner_id
      ) {
        const currentPractitionerData = allPractitionersNames.find(
          (practitioner) =>
            practitioner.practitioner_id === currentPractitioner.practitioner_id
        );
        if (currentPractitionerData) {
          dataArr.push({
            value: currentPractitionerData?.practitioner_id,
            label: `${
              currentPractitionerData?.practitioner_title
                ? currentPractitionerData.practitioner_title + '. '
                : ''
            }${currentPractitionerData?.practitioner_name}`,
          });
        }
      }

      filteredPractitioners.forEach((key) => {
        if (key?.practitioner_id !== currentPractitioner?.practitioner_id) {
          dataArr.push({
            value: key?.practitioner_id,
            label: `${
              key?.practitioner_title ? key.practitioner_title + '. ' : ''
            }${key?.practitioner_name}`,
          });
        }
      });
      setAllPractitionerNames(dataArr);
    }
  }, [allPractitionersNames, settingsOrgValue, currentPractitioner]);

  // Mobile detection for responsive button text
  const [isShowEncounterTooltip, setIsShowEncounterTooltip] = useState(
    window.innerWidth < 1400
  );

  useEffect(() => {
    const handleResize = () => {
      setIsShowEncounterTooltip(window.innerWidth < 1400);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const practitioner_options = () => {
    const filteredPractitioners = getAllPractitionerNames.filter(
      (practitioner) => practitioner.value !== org_Practitioner_id
    );
    return filteredPractitioners.length > 0
      ? filteredPractitioners.map((practitioner) => ({
          key: practitioner.value,
          label: <span className=""> {practitioner.label} </span>,
        }))
      : [];
  };

  const onChangePatientHandler = (value, fieldName, date, patient_id) => {
    if (!isEmpty(value)) {
      setSearchFilters({
        ...searchFilters,
        ['patientName']: value,
        patient_id: patient_id ? patient_id : '',
      });
    } else {
      const {
        patientName: _patientName,
        patient_id: _patient_id,
        ...restFilters
      } = searchFilters;
      setSearchFilters(restFilters);
    }
  };

  useEffect(() => {
    const uniquePatientNames = new Set();
    const PatientArray = practitionersAndPatients?.patient?.reduce(
      (accumulator, patient) => {
        const patientName = `${patient?.patient_Name} (${patient?.patient_id})`;
        if (!uniquePatientNames.has(patientName)) {
          uniquePatientNames.add(patientName);
          accumulator.push({
            id: patient?.patient_Name,
            value: patient?.patient_Name,
            patient_id: patient?.patient_id,
            patient_dob: patient?.patient_birth_date
              ? moment(patient.patient_birth_date).format('MM/DD/YYYY')
              : null,
            appointment_date: patient?.appointment_date
              ? moment(patient.appointment_date).format('MM/DD/YYYY')
              : null,
            ehr_id: patient?.ehr_id,
          });
        }
        return accumulator;
      },
      []
    );
    setPatientArray(PatientArray);
  }, [practitionersAndPatients]);

  const performFuzzySearch = (value) => {
    const search = value.toLowerCase().trim();
    if (!patientArray || !patientArray) {
      return [];
    }

    return patientArray.filter((patient) => {
      return (
        patient.value.toLowerCase().includes(search) ||
        String(patient.patient_id).toLowerCase().includes(search) ||
        (patient.ehr_id &&
          String(patient.ehr_id).toLowerCase().includes(search)) ||
        (patient.patient_dob &&
          patient.patient_dob.toLowerCase().includes(search))
      );
    });
  };

  useEffect(() => {
    let practitionerObj = isScribeSelected
      ? scribeOptions.find((option) => option.value === selectedPractitioner)
      : undefined;

    if (!practitionerObj) {
      practitionerObj = options.find(
        (option) => option.value === selectedPractitioner
      );
    }

    if (
      practitionerObj &&
      (practitionerObj?.value !== selectedPractitionerObj?.value ||
        practitionerObj?.name !== selectedPractitionerObj?.name)
    ) {
      setSelectedPractitionerObj(practitionerObj);
    }
  }, [selectedPractitioner, isScribeSelected, scribeOptions, options]);

  const handleAddEncounterClick = () => {
    setSelectedFilter('Today');
  };

  const formatLegalConfirmationType = (type) => {
    if (!type || type === 'first') return '';
    return `#${type}`;
  };

  return (
    <>
      {isFreeUser &&
        totalEncounterWillBeArchived > 0 &&
        showExpirationBanner && (
          <Alert
            message={
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <ExclamationCircleOutlined
                  style={{ marginRight: '8px', color: '#F59E0B' }}
                />
                {totalEncounterWillBeArchived} notes will be deleted in{' '}
                {EXPIRATION_WARNING_DAYS} days. Free plan notes are retained for{' '}
                {FREE_TIER_RETENTION_DAYS} days only.
                <Button
                  type="default"
                  onClick={() => {
                    analytics.track('Clicked Upgrade For Longer Retention', {
                      email: user?.email,
                    });
                    handleUpgradeToProModal();
                  }}
                  style={{
                    marginLeft: 'auto',
                    backgroundColor: '#F59E0B',
                    color: '#ffffff',
                    borderColor: '#FFC107',
                    borderRadius: '6px',
                    fontWeight: '500',
                    padding: '0px 15px',
                    height: 'auto',
                    lineHeight: 'initial',
                    fontSize: '12px',
                  }}
                >
                  Upgrade for longer retention
                </Button>
              </span>
            }
            type="warning"
            closable
            onClose={() => {
              analytics.track(
                'Clicked Close Banner From Data Retention Warning Banner',
                {
                  email: user?.email,
                }
              );
              setShowExpirationBanner(false);
              storeInLocal(
                EXPIRATION_BANNER_CLOSED_TIMESTAMP_KEY,
                Date.now().toString()
              );
            }}
            style={{
              marginBottom: '16px',
              borderRadius: '8px',
              backgroundColor: '#fffbe6',
              borderColor: '#ffe58f',
            }}
            className="encounter-expiration-banner"
          />
        )}
      {isMobileView && !schedulepage && selectedTab ? (
        // Mobile view starts here
        <>
          {!isMobileRecord && !schedulepage && (
            <div className="flex justify-center items-center past mb-3 w-full">
              <Segmented
                size="small"
                block
                options={['Today', 'Yesterday', 'Past 7 days', 'All time']}
                onChange={(key) => handleTabChange(key)}
                className="w-full"
                value={storeSavedTabMobile ? storeSavedTabMobile : selectedTab}
              />
            </div>
          )}
          <div className=" justify-start mb-2 past h-10 items-center bg-white shadow-sm rounded-xl flex">
            <SelectHover
              popupClassName={`font-sans`}
              className="font-normal text-sm text-black flex items-center"
              options={options}
              filterOption={(inputValue, option) =>
                option && option.name
                  ? option.name
                      .toLowerCase()
                      .indexOf(inputValue.toLowerCase()) !== -1
                  : false
              }
              placeholder="Select practitioner"
              onChange={(e, option) => onChange(e, option, 'practitioner')}
              loading={practitionerListLoading}
              value={
                selectedPractitioner
                  ? selectedPractitionerObj && {
                      label: selectedPractitionerObj.label,
                      value: selectedPractitioner,
                    }
                  : loggedInSelectedPractitioner
              }
              optionFilterProp="label"
              showSearch
              allowClear
              labelInValue
            />
          </div>
          <div
            className="w-full mb-2 drop-shadow-sm bg-white rounded-xl"
            id="PatientSearch"
          >
            <AutoComplete
              variant="borderless"
              className="border-none font-sans h-10 text-base flex items-center w-full border-0 focus:outline-none placeholder-gray-500 pr-4"
              id="PatientSearchField"
              style={{
                WebkitTextFillColor: 'gray',
              }}
              options={
                showDropdown &&
                (showNoData
                  ? [
                      {
                        value: 'No data',
                        label: 'No data',
                        disabled: true,
                      },
                    ]
                  : filteredPatientNames.map((patient) => ({
                      ...patient,
                      key: patient.patient_id,
                      value: `${patient.value}_${patient.patient_id}`,
                      label: (
                        <div className="w-full">
                          <div>{patient.value}</div>
                          <div className="flex flex-row justify-start gap-2">
                            <div className="text-[11px] text-[#777777]">
                              DOB: {patient.patient_dob}
                            </div>
                            <div className="text-[11px] text-[#777777]">
                              Patient ID: {patient.patient_id}
                            </div>
                          </div>
                          {patient?.ehr_id && (
                            <div className="flex flex-row justify-start gap-2">
                              <Tooltip
                                title={
                                  patient.ehr_id.length > 15
                                    ? patient.ehr_id
                                    : ''
                                }
                                className="text-[11px] text-[#777777]"
                              >
                                <div className="text-[11px] text-[#777777]">
                                  EHR/MRN ID:{' '}
                                  {patient.ehr_id.length > 15
                                    ? `${patient.ehr_id.substring(0, 15)}...`
                                    : patient.ehr_id}
                                </div>
                              </Tooltip>
                            </div>
                          )}
                          {patient.appointment_date && (
                            <div
                              className={`text-[11px] ${
                                moment(patient.appointment_date).isBefore(
                                  moment(),
                                  'day'
                                )
                                  ? 'text-[#ff0000]'
                                  : 'text-[#16a878]'
                              }`}
                            >
                              {moment(patient.appointment_date).isBefore(
                                moment(),
                                'day'
                              )
                                ? `Past appt.: ${patient.appointment_date}`
                                : `Next appt.: ${patient.appointment_date}`}
                            </div>
                          )}
                        </div>
                      ),
                    })))
              }
              placeholder="Patient"
              filterOption={false}
              value={
                searchFilters?.patientName
                  ? filteredPatientNames.find(
                      (opt) => opt.id === searchFilters.patientName
                    )?.id || searchFilters?.patientName
                  : ''
              }
              suffixIcon={
                searchFilters?.patientName ? (
                  <CloseOutlined
                    onClick={() => {
                      onChangePatientHandler('', 'patientName', null, '');
                      setShowDropdown(false);
                      setShowNoData(false);
                    }}
                    style={{
                      cursor: 'pointer',
                    }}
                    className="hover:text-gray-700 transition-colors duration-200"
                  />
                ) : (
                  <SearchIcon />
                )
              }
              onChange={(value, option) => {
                setShowDropdown(false);
                // Filter patient names based on user input
                const filteredNames = performFuzzySearch(option?.id || value);
                // Set the showNoData flag if there are no matching names
                setShowNoData(filteredNames?.length === 0);
                setFilteredPatientNames(filteredNames);

                // If the user tries to select "No data," clear the selection
                if (
                  option?.id
                    ? option?.id?.toLowerCase() === 'no data'
                    : value?.toLowerCase() === 'no data'
                ) {
                  onChangePatientHandler('', 'patientName', null, '');
                } else {
                  onChangePatientHandler(
                    option?.id || value,
                    'patientName',
                    null,
                    option?.patient_id
                  );
                  setShowDropdown(true);
                }
              }}
              dropdownStyle={{
                width: '232px',
              }}
            />
          </div>
          <div
            id="CustomFilter"
            className="w-full h-10 flex items-center drop-shadow-sm bg-white rounded-xl text-sm justify-around mb-2"
          >
            <Select
              prefix={<RecentSearchIcon />}
              // dropdownStyle={{ width: '300px' }}
              bordered={false}
              className="border-none truncate font-sans text-base flex items-center w-full border-0 focus:outline-none mt-1  pr-4"
              popupClassName="mobile-select-dropdown font-sans"
              value={
                renameTitleEncounter || selectedTitleEncounter || 'Custom views'
              }
              // placeholder="Custom search"
              optionFilterProp="label"
              showSearch={false}
              dropdownStyle={{
                maxHeight: '200px',
                overflow: 'auto',
              }}
            >
              <Select.Option disabled key="save_view" value="save_view">
                <button
                  onClick={handleAddLabel}
                  type="button"
                  className="flex items-center py-2 px-1 hover:bg-gray-100 rounded-md text-left w-full"
                >
                  <TagIcon className="mr-2" fill="#000000" />
                  <span className="text-black">Save this view...</span>
                </button>
              </Select.Option>
              <Select.Option disabled key="manage-view">
                <div className="">
                  <button
                    className="flex items-center py-2 px-1 hover:bg-gray-100 rounded-md text-left w-full"
                    type="button"
                    onClick={handleMangeViews}
                  >
                    <ManageViewsIcon className="mr-2" fill="#000000" />
                    <span className="text-black">Manage views...</span>
                  </button>
                </div>
              </Select.Option>
              {Array.isArray(recentSearchList?.search_preference) &&
                recentSearchList?.search_preference.length > 0 && (
                  <Select.Option disabled key="recent-searches-heading">
                    <div className="text-gray-400">My views</div>
                  </Select.Option>
                )}
              {Array.isArray(recentSearchList?.search_preference) &&
                recentSearchList?.search_preference.map((search, index) => {
                  const uniqueKey = searchPractitionerKey(search, index);
                  return (
                    <Select.Option
                      key={uniqueKey}
                      value={search?.practitioners
                        ?.map((p) => p.practitionerId)
                        .flat()}
                      label={search?.practitioners
                        ?.map((p) => p.practitionerName)
                        .join(', ')}
                    >
                      <button
                        type="button"
                        className="w-full text-left py-1"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleRecentSearchSelect(search);
                          setSelectedTitleEncounter(search.title);
                          localStorage.setItem(
                            `${currentPractitioner?.org_uuid}_selectedTitleEncounter`,
                            search.title
                          );
                        }}
                      >
                        <div className="flex justify-between gap-1 text-wrap">
                          {search?.title && <div>{search?.title}</div>}
                          {search?.isDefaultView ? (
                            <div className={`flex auraonly-radio-outlook`}>
                              Default View
                            </div>
                          ) : (
                            <button
                              className="hover:bg-[#E5E8EB] hover:underline underline-offset-2 decoration-black text-black rounded-xl drop-shadow-sm px-4 py-2.5 mr-2 h-10 flex items-center shrink-0 font-normal text-[12px]"
                              onClick={() => handleSetDefault(search)}
                            >
                              Set as Default
                            </button>
                          )}
                        </div>
                      </button>
                    </Select.Option>
                  );
                })}
            </Select>
            <SavedSearchEncounterModal
              isEncounterVisible={isEncounterVisible}
              handleCloseView={handleCloseView}
              selectedDate={selectedDate}
              selectedPractitioner={
                options.find((option) => option.value === selectedPractitioner)
                  ?.name || 'All Practitioners'
              }
              isDefaultView={isDefaultView}
              setDefaultPreferenceValue={setDefaultPreferenceValue}
              handleSaveView={handleSaveView}
              selectedFilter={selectedFilter}
              setRenameTitleEncounter={setRenameTitleEncounter}
              renameTitleEncounter={renameTitleEncounter}
              handleSaveDuplicate={handleSaveDuplicate}
              setDuplicateError={setDuplicateError}
              duplicateError={duplicateError}
              selectedTab={selectedTab}
              searchFilters={searchFilters}
            />
            <ManageSearchEncounterModal
              setRenameTitleEncounter={setRenameTitleEncounter}
              isMangeViewOpen={isMangeViewOpen}
              handleMangeViews={handleMangeViews}
              handleCloseManageView={handleCloseManageView}
              recentSearchList={recentSearchList}
              renameTitleEncounter={renameTitleEncounter}
              selectedTitleEncounter={selectedTitleEncounter}
              resetFilters={resetFilters}
              searchFilters={searchFilters}
            />
          </div>
          <div className="flex justify-between gap-2">
            <div className="bg-white w-52 p-1 mb-2 rounded-xl drop-shadow-sm flex items-center tree-dropdown">
              <label
                htmlFor="status"
                className="mr-1 ml-2 text-sm text-black whitespace-nowrap"
              >
                Status
              </label>
              <div className="flex flex-col md:flex-row gap-2 justify-between items-center flex-nowrap">
                <div className="grow shrink-0 w-full">
                  <TreeSelectDropdown
                    suffixIcon={
                      <ExpandIcon
                        fill={'#000000'}
                        className="mr-3 absolute ml-2"
                      />
                    }
                    bordered={false}
                    showSearch={false}
                    popupClassName="!w-48"
                    className="h-8 !w-32 2xl:!w-40 bg-transparent border-none focus:border-none rounded-xl caret-transparent flex items-center hover:bg-transparent -mb-0"
                    options={statusOptions}
                    filterOption={(inputValue, option) =>
                      option && option.title
                        ? option.title
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        : false
                    }
                    placeholder="Select status"
                    onChange={handleStatusChange}
                    loading={practitionerListLoading}
                    value={searchFilters?.status ? searchFilters?.status : ''}
                  />
                </div>
              </div>
            </div>
            <button
              className=" hover:bg-gray-100 rounded-xl h-10 px-4 font-normal text-sm text-black drop-shadow-sm  hover:underline underline-offset-2 decoration-black"
              onClick={resetFilters}
            >
              Clear filters
            </button>
          </div>
        </>
      ) : (
        // Mobile view ends here
        //Desktop view starts here
        <>
          {legalConfirmation?.show && (
            <Alert
              message={
                <>
                  <div className="flex flex-row justify-between items-center">
                    <span className="text-sm">
                      Opie AI is here to help — but you make the final call.
                      Please review each note to confirm that it reflects your
                      clinical judgment.
                    </span>
                    <div>
                      <Button
                        type="default"
                        size="small"
                        className="!bg-[#faad14] !text-white !border-[#faad14] hover:!bg-[#eda017] hover:!border-[#eda017]"
                        onClick={() => {
                          analytics.track(
                            `Clicked OK In Opie AI ${formatLegalConfirmationType(
                              legalConfirmation?.type
                            )} Legal Confirmation Banner`,
                            {
                              email: user?.email,
                            }
                          );
                          dispatch(
                            updateLegalConfirmationAction(
                              legalConfirmation?.type
                            )
                          );
                        }}
                      >
                        <span className="text-sm ml-6 mr-6">OK</span>
                      </Button>
                    </div>
                  </div>
                </>
              }
              type="warning"
              showIcon
              className="mb-4"
            />
          )}
          <div className="flex flex-col sm:flex-row lg:justify-between justify-center flex-wrap gap-2 items-center">
            {!schedulepage && (
              <div className="flex flex-col sm:flex-row">
                <div className="flex justify-between gap-4 xl:gap-2">
                  <>
                    <div
                      id="PractitionerFilter"
                      className="bg-white shadow-sm rounded-xl md:w-44 lg:w-48 xl:w-40 2xl:w-48 flex items-center"
                    >
                      {practitionerListLoading || !currentPractitioner ? (
                        <div className="font-normal text-sm text-gray-400 flex items-center cursor-pointer px-3 py-2 border-none bg-white rounded-xl w-full justify-between">
                          <span className="whitespace-nowrap overflow-hidden text-ellipsis max-w-[90%]">
                            Loading...
                          </span>
                        </div>
                      ) : isHumanScribeEntitled ? (
                        selectedPractitioner ? (
                          selectedPractitionerObj && (
                            <Dropdown
                              arrow={true}
                              trigger={['click']}
                              menu={{
                                items: [
                                  {
                                    key: 'practitioners',
                                    label: (
                                      <div className="flex items-center gap-2">
                                        <AudioOutlined />
                                        Practitioners
                                      </div>
                                    ),
                                    children: options.map((option) => ({
                                      key: `practitioner-${option.value}`,
                                      label: option.label,
                                      value: option.value,
                                      name: option.name,
                                    })),
                                    popupClassName: '',
                                  },
                                  {
                                    key: 'scribes',
                                    label: (
                                      <div className="flex items-center gap-2">
                                        <SignatureOutlined />
                                        Scribes
                                      </div>
                                    ),
                                    children: scribeOptions.map((option) => ({
                                      key: `scribe-${option.value}`,
                                      label: option.label,
                                      value: option.value,
                                      name: option.name,
                                    })),
                                    popupClassName: '',
                                  },
                                ],
                                onClick: ({ key, keyPath, domEvent }) => {
                                  domEvent.stopPropagation();
                                  const type = keyPath[1];
                                  const originalKey = key.replace(
                                    /^(practitioner-|scribe-)/,
                                    ''
                                  );
                                  const option =
                                    type === 'practitioners'
                                      ? options.find(
                                          (opt) => opt.value === originalKey
                                        )
                                      : scribeOptions.find(
                                          (opt) => opt.value === originalKey
                                        );
                                  onChange(
                                    originalKey,
                                    option,
                                    'practitioner',
                                    type
                                  );
                                },
                              }}
                              placement="bottomLeft"
                            >
                              <div className="font-normal text-sm text-black flex items-center cursor-pointer px-3 py-2 border-none bg-white rounded-xl w-full justify-between">
                                <span className="whitespace-nowrap overflow-hidden text-ellipsis max-w-[90%]">
                                  {selectedPractitionerObj.name}
                                </span>
                                <ExpandIcon fill={'#000000'} />
                              </div>
                            </Dropdown>
                          )
                        ) : (
                          <Dropdown
                            arrow={true}
                            trigger={['click']}
                            menu={{
                              items: [
                                {
                                  key: 'practitioners',
                                  label: (
                                    <div className="flex items-center gap-2">
                                      <AudioOutlined />
                                      Practitioners
                                    </div>
                                  ),
                                  children: options.map((option) => ({
                                    key: `practitioner-${option.value}`,
                                    label: option.label,
                                    value: option.value,
                                    name: option.name,
                                  })),
                                  popupClassName: 'limited-submenu',
                                },
                                {
                                  key: 'scribes',
                                  label: (
                                    <div className="flex items-center gap-2">
                                      <SignatureOutlined />
                                      Scribes
                                    </div>
                                  ),
                                  children: scribeOptions.map((option) => ({
                                    key: `scribe-${option.value}`,
                                    label: option.label,
                                    value: option.value,
                                    name: option.name,
                                  })),
                                  popupClassName: 'limited-submenu',
                                },
                              ],
                              onClick: ({ key, keyPath, domEvent }) => {
                                domEvent.stopPropagation();
                                const type = keyPath[1];
                                const originalKey = key.replace(
                                  /^(practitioner-|scribe-)/,
                                  ''
                                );
                                const option =
                                  type === 'practitioners'
                                    ? options.find(
                                        (opt) => opt.value === originalKey
                                      )
                                    : scribeOptions.find(
                                        (opt) => opt.value === originalKey
                                      );
                                onChange(
                                  originalKey,
                                  option,
                                  'practitioner',
                                  type
                                );
                              },
                            }}
                            placement="bottomLeft"
                          >
                            <div className="font-normal text-sm text-black flex justify-between items-center cursor-pointer px-3 py-2">
                              <span className="whitespace-nowrap overflow-hidden text-ellipsis max-w-[90%]">
                                {loggedInSelectedPractitioner ||
                                  'Select practitioner'}
                              </span>
                              <ExpandIcon fill={'#000000'} />
                            </div>
                          </Dropdown>
                        )
                      ) : selectedPractitioner ? (
                        selectedPractitionerObj && (
                          <SelectHover
                            bordered={false}
                            popupClassName={`font-sans`}
                            className="font-normal text-sm text-black flex items-center border-none bg-white rounded-xl py-1 outline-none w-full"
                            options={options}
                            filterOption={(inputValue, option) =>
                              option && option.name
                                ? option?.name
                                    ?.toLowerCase()
                                    .indexOf(inputValue.toLowerCase()) !== -1
                                : false
                            }
                            placeholder="Select practitioner"
                            onChange={(e, option) =>
                              onChange(e, option, 'practitioner')
                            }
                            loading={practitionerListLoading}
                            value={{
                              label: selectedPractitionerObj.label,
                              value: selectedPractitioner,
                            }}
                            optionFilterProp="label"
                            showSearch
                            allowClear
                            labelInValue
                            dropdownId="custom-dropdown-id"
                          />
                        )
                      ) : (
                        <SingleSelect
                          bordered={false}
                          popupClassName={`font-sans`}
                          className="font-normal text-sm text-black flex items-center"
                          options={options}
                          filterOption={(inputValue, option) =>
                            option && option.name
                              ? option.name
                                  .toLowerCase()
                                  .indexOf(inputValue.toLowerCase()) !== -1
                              : false
                          }
                          placeholder="Select practitioner"
                          onChange={(e, option) =>
                            onChange(e, option, 'practitioner')
                          }
                          loading={practitionerListLoading}
                          value={loggedInSelectedPractitioner}
                          optionFilterProp="label"
                          showSearch
                          allowClear
                          labelInValue
                        />
                      )}
                    </div>
                    <div
                      className="w-full md:w-36 drop-shadow-sm bg-white rounded-xl"
                      id="PatientSearch"
                    >
                      <AutoComplete
                        variant="borderless"
                        className="border-none font-sans h-10 text-base flex items-center w-full border-0 focus:outline-none placeholder-gray-500 pr-4"
                        id="PatientSearchField"
                        style={{
                          WebkitTextFillColor: 'gray',
                        }}
                        options={
                          showDropdown &&
                          (showNoData
                            ? [
                                {
                                  value: 'No data',
                                  label: 'No data',
                                  disabled: true,
                                },
                              ]
                            : filteredPatientNames.map((patient) => ({
                                ...patient,
                                key: patient.patient_id,
                                value: `${patient.value}_${patient.patient_id}`,
                                label: (
                                  <div>
                                    <div>{patient.value}</div>
                                    <div className="flex flex-row justify-start gap-2">
                                      <div className="text-[11px] text-[#777777]">
                                        DOB: {patient.patient_dob}
                                      </div>
                                      <div className="text-[11px] text-[#777777]">
                                        Patient ID: {patient.patient_id}
                                      </div>
                                    </div>
                                    {patient?.ehr_id && (
                                      <div className="flex flex-row justify-start gap-2">
                                        <Tooltip
                                          title={
                                            patient.ehr_id.length > 15
                                              ? patient.ehr_id
                                              : ''
                                          }
                                          className="text-[11px] text-[#777777]"
                                        >
                                          <div className="text-[11px] text-[#777777]">
                                            EHR/MRN ID:{' '}
                                            {patient.ehr_id.length > 15
                                              ? `${patient.ehr_id.substring(
                                                  0,
                                                  15
                                                )}...`
                                              : patient.ehr_id}
                                          </div>
                                        </Tooltip>
                                      </div>
                                    )}
                                    {patient.appointment_date && (
                                      <div
                                        className={`text-[11px] ${
                                          moment(
                                            patient.appointment_date
                                          ).isBefore(moment(), 'day')
                                            ? 'text-[#ff0000]'
                                            : 'text-[#16a878]'
                                        }`}
                                      >
                                        {moment(
                                          patient.appointment_date
                                        ).isBefore(moment(), 'day')
                                          ? `Past appt.: ${patient.appointment_date}`
                                          : `Next appt.: ${patient.appointment_date}`}
                                      </div>
                                    )}
                                  </div>
                                ),
                              })))
                        }
                        placeholder="Patient"
                        filterOption={false}
                        value={
                          searchFilters?.patientName
                            ? filteredPatientNames.find(
                                (opt) => opt.id === searchFilters.patientName
                              )?.id || searchFilters?.patientName
                            : ''
                        }
                        suffixIcon={
                          searchFilters?.patientName ? (
                            <CloseOutlined
                              onClick={() => {
                                onChangePatientHandler(
                                  '',
                                  'patientName',
                                  null,
                                  ''
                                );
                                setShowDropdown(false);
                                setShowNoData(false);
                              }}
                              style={{
                                cursor: 'pointer',
                              }}
                              className="hover:text-gray-700 transition-colors duration-200"
                            />
                          ) : (
                            <SearchIcon />
                          )
                        }
                        onChange={(value, option) => {
                          setShowDropdown(false);
                          // Filter patient names based on user input
                          const filteredNames = performFuzzySearch(
                            option?.id || value
                          );
                          // Set the showNoData flag if there are no matching names
                          setShowNoData(filteredNames?.length === 0);
                          setFilteredPatientNames(filteredNames);

                          // If the user tries to select "No data," clear the selection
                          if (
                            option?.id
                              ? option?.id?.toLowerCase() === 'no data'
                              : value?.toLowerCase() === 'no data'
                          ) {
                            onChangePatientHandler('', 'patientName', null, '');
                          } else {
                            onChangePatientHandler(
                              option?.id || value,
                              'patientName',
                              null,
                              option?.patient_id
                            );
                            setShowDropdown(true);
                          }
                        }}
                        dropdownStyle={{
                          width: '232px',
                        }}
                      />
                    </div>
                    <div className="bg-white p-1 rounded-xl drop-shadow-sm flex items-center tree-dropdown ">
                      <label
                        htmlFor="status"
                        className="mr-1 ml-2 text-xs text-black whitespace-nowrap "
                      >
                        Status
                      </label>
                      <div className="flex flex-col md:flex-row gap-1 justify-between items-center flex-nowrap">
                        <div id="StatusFilter" className="grow shrink-0 w-full">
                          <TreeSelectDropdown
                            suffixIcon={
                              <ExpandIcon
                                fill={'#000000'}
                                className="mr-3 absolute ml-2 "
                              />
                            }
                            bordered={false}
                            showSearch={false}
                            popupClassName="!w-50 !max-height-none"
                            dropdownStyle={{ maxHeight: 'none' }}
                            className="h-8 lg:!w-[144px] 2xl:!w-32 bg-transparent border-none focus:border-none rounded-xl mr-3 caret-transparent flex items-center hover:bg-transparent -mb-0"
                            options={
                              isHumanScribeEntitled
                                ? humanScribeStatusOptions
                                : statusOptions
                            }
                            filterOption={(inputValue, option) =>
                              option && option.title
                                ? option.title
                                    .toLowerCase()
                                    .includes(inputValue.toLowerCase())
                                : false
                            }
                            placeholder="Select status"
                            onChange={handleStatusChange}
                            loading={practitionerListLoading}
                            value={
                              searchFilters?.status ? searchFilters?.status : ''
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {/* Date filter dropdown : start */}
                    {auraView === 'LIST' && (
                      <div
                        className=""
                        style={{ position: 'relative', zIndex: '10' }}
                      >
                        <EncounterDateFilter
                          currentDate={currentDate}
                          setCurrentDate={setCurrentDate}
                          renderCalendar={renderCalendar}
                          handleDateFilterChange={handleDateFilterChange}
                          resetDateFilter={resetDateFilter}
                          setIsResetFiltersOn={setIsResetFiltersOn}
                          setResetDateFilter={setResetDateFilter}
                          setSelectedFilter={setSelectedFilter}
                          selectedFilter={selectedFilter}
                          selectedDate={selectedDate}
                          setSelectedDate={setSelectedDate}
                          selectedDates={selectedDates}
                          setSelectedDates={setSelectedDates}
                          startDateRange={startDateRange}
                          setStartDateRange={setStartDateRange}
                          endDateRange={endDateRange}
                          setEndDateRange={setEndDateRange}
                        />
                      </div>
                    )}
                    {auraView === 'LIST' && (
                      <div
                        id="CustomFilter"
                        className="w-full md:w-36 lg:w-52 xl:w-40 2xl:w-52 h-10 flex items-center drop-shadow-sm bg-white rounded-xl text-sm justify-around "
                      >
                        <div className="ml-2">
                          <RecentSearchIcon />
                        </div>
                        <Select
                          dropdownStyle={{ width: '300px' }}
                          bordered={false}
                          className="border-none truncate font-sans text-base flex items-center w-full border-0 focus:outline-none -mb-0.5 pr-4"
                          value={
                            renameTitleEncounter ||
                            selectedTitleEncounter ||
                            'Custom views'
                          }
                          placeholder="Custom search"
                          optionFilterProp="label"
                          showSearch={false}
                        >
                          <Select.Option
                            disabled
                            key="save_view"
                            value="save_view"
                          >
                            <button
                              onClick={handleAddLabel}
                              type="button"
                              className="flex items-center py-2 px-1 hover:bg-gray-100 rounded-md text-left w-full"
                            >
                              <TagIcon className="mr-2" fill="#000000" />
                              <span className="text-black">
                                Save this view...
                              </span>
                            </button>
                          </Select.Option>
                          <Select.Option disabled key="manage-view">
                            <div className="">
                              <button
                                className="flex items-center py-2 px-1 hover:bg-gray-100 rounded-md text-left w-full"
                                type="button"
                                onClick={handleMangeViews}
                              >
                                <ManageViewsIcon
                                  className="mr-2"
                                  fill="#000000"
                                />
                                <span className="text-black">
                                  Manage views...
                                </span>
                              </button>
                            </div>
                          </Select.Option>
                          {Array.isArray(recentSearchList?.search_preference) &&
                            recentSearchList?.search_preference.length > 0 && (
                              <Select.Option
                                disabled
                                key="recent-searches-heading"
                              >
                                <div className="text-gray-400">My views</div>
                              </Select.Option>
                            )}
                          {Array.isArray(recentSearchList?.search_preference) &&
                            recentSearchList?.search_preference.map(
                              (search, index) => {
                                const uniqueKey = searchPractitionerKey(
                                  search,
                                  index
                                );
                                return (
                                  <Select.Option
                                    key={uniqueKey}
                                    value={search?.practitioners
                                      ?.map((p) => p.practitionerId)
                                      .flat()}
                                    label={search?.practitioners
                                      ?.map((p) => p.practitionerName)
                                      .join(', ')}
                                  >
                                    <button
                                      type="button"
                                      className="w-full text-left py-1"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleRecentSearchSelect(search);
                                        setSelectedTitleEncounter(search.title);
                                        localStorage.setItem(
                                          `${currentPractitioner?.org_uuid}_selectedTitleEncounter`,
                                          search.title
                                        );
                                        setIsResetFiltersOn(false);
                                      }}
                                    >
                                      <div className="flex justify-between gap-1">
                                        {search?.title && (
                                          <div>{search?.title}</div>
                                        )}
                                        {search?.isDefaultView ? (
                                          <div
                                            className={`flex auraonly-radio-outlook`}
                                          >
                                            Default View
                                          </div>
                                        ) : (
                                          <button
                                            className="hover:bg-[#E5E8EB] hover:underline underline-offset-2 decoration-black text-black rounded-xl drop-shadow-sm py-[3px] px-[10px] flex items-center shrink-0 font-normal text-[12px]"
                                            onClick={() =>
                                              handleSetDefault(search)
                                            }
                                          >
                                            Set as Default
                                          </button>
                                        )}
                                      </div>
                                    </button>
                                  </Select.Option>
                                );
                              }
                            )}
                        </Select>
                        <SavedSearchEncounterModal
                          isEncounterVisible={isEncounterVisible}
                          handleCloseView={handleCloseView}
                          selectedDate={selectedDate}
                          selectedFilter={selectedFilter}
                          selectedPractitioner={
                            options.find(
                              (option) => option.value === selectedPractitioner
                            )?.name || 'All Practitioners'
                          }
                          isDefaultView={isDefaultView}
                          setDefaultPreferenceValue={setDefaultPreferenceValue}
                          handleSaveView={handleSaveView}
                          setRenameTitleEncounter={setRenameTitleEncounter}
                          renameTitleEncounter={renameTitleEncounter}
                          handleSaveDuplicate={handleSaveDuplicate}
                          setDuplicateError={setDuplicateError}
                          duplicateError={duplicateError}
                          searchFilters={searchFilters}
                        />
                        <ManageSearchEncounterModal
                          setRenameTitleEncounter={setRenameTitleEncounter}
                          isMangeViewOpen={isMangeViewOpen}
                          handleMangeViews={handleMangeViews}
                          handleCloseManageView={handleCloseManageView}
                          recentSearchList={recentSearchList}
                          renameTitleEncounter={renameTitleEncounter}
                          selectedTitleEncounter={selectedTitleEncounter}
                          resetFilters={resetFilters}
                          searchFilters={searchFilters}
                        />
                      </div>
                    )}
                    {!isResetFiltersOn && !schedulepage && (
                      <button
                        type="button"
                        className="hover:bg-[#E5E8EB] hover:underline underline-offset-2 decoration-black text-black rounded-xl drop-shadow-sm px-1 py-2.5 h-10 flex items-center shrink-0 font-normal text-[12px]"
                        onClick={resetFilters}
                      >
                        Clear
                      </button>
                    )}
                  </>
                </div>
              </div>
            )}
            <ZoomMeetingModal
              showZoomModal={showZoomModal}
              setShowZoomModal={setShowZoomModal}
              setupJoinButtonAutomation={setupJoinButtonAutomation}
              handleCreateEncounter={handleCreateEncounter}
              onMeetingJoined={handleOpenBasicModal}
            />
            {!schedulepage && (
              <div className="flex xl:float-right">
                {!isMobileView && (
                  <>
                    <Tooltip title="Toggle Aura AI view" placement="topRight">
                      <div className="settings-component px-1">
                        <Radio.Group
                          value={auraView}
                          onChange={(e) => {
                            handleAuraCalenderTabChange(e.target.value);
                          }}
                          className="flex justify-between items-center cursor-pointer"
                        >
                          <Radio.Button
                            className="p-2 h-[38px]"
                            key={'LIST'}
                            value={'LIST'}
                          >
                            <ListIcon />
                          </Radio.Button>

                          <Radio.Button
                            className="p-2  h-[38px]"
                            key={'CALENDAR'}
                            value={'CALENDAR'}
                          >
                            <CalendarIcon />
                          </Radio.Button>
                        </Radio.Group>
                      </div>
                    </Tooltip>
                    {zoomEncountersAccess &&
                      localPractitionerSettings?.note_preferences
                        ?.enable_zoom_integration && (
                        <ZoomEncounterModal
                          setShowZoomModal={setShowZoomModal}
                        />
                      )}
                    {!hasCreateEncountersOnBehalfOfAccess ||
                    practitioner_options().length === 0 ||
                    (hasCreateEncountersOnBehalfOfAccess &&
                      !createEncountersOnBehalfOf) ? (
                      <Tooltip
                        title={createEncounterTooltipText}
                        placement="bottomRight"
                        styles={{ root: { maxWidth: '250px' } }}
                        arrow={{ pointAtCenter: true }}
                      >
                        <Button
                          className={`${
                            isCreateEncounterAllowed
                              ? 'ih-button-primary'
                              : 'ih-button-secondary'
                          }`}
                          onClick={() => {
                            if (isCreateEncounterAllowed) {
                              handleCreateEncounter(
                                currentPractitioner?.practitioner_id,
                                { is_pinned_encounter: true }
                              );
                              setSelectedPractitioner(
                                currentPractitioner?.practitioner_id
                              );
                              setSearchFilters((prevFilters) => ({
                                ...prevFilters,
                                practitioner_id:
                                  currentPractitioner?.practitioner_id,
                              }));
                              setPageState({
                                current: 1,
                                pageSize: DEFAULT_PAGE_SIZE,
                              });
                              changeEncounterStatus(record?.encounter_id);
                              handleAddEncounterClick();
                            } else {
                              setIsUpgradeModalVisible(true);
                            }
                          }}
                          size="large"
                        >
                          <div
                            className="flex past-encounter-div px-1 gap-1"
                            id="add_encounter"
                          >
                            {isShowEncounterTooltip ? (
                              <Tooltip
                                title="Add encounter"
                                placement="topRight"
                              >
                                <span className="text-white text-2xl">+</span>
                              </Tooltip>
                            ) : (
                              <>
                                <PlusOutlined />
                                <span className="font-sans">Add encounter</span>
                              </>
                            )}
                          </div>
                        </Button>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={createEncounterTooltipText}
                        placement="bottomRight"
                        styles={{ root: { maxWidth: '250px' } }}
                        arrow={{ pointAtCenter: true }}
                      >
                        <Dropdown.Button
                          type="primary"
                          placement="bottomLeft"
                          icon={<ExpandIcon fill="#ffffff" />}
                          menu={{
                            className:
                              practitioner_options().length <= 6
                                ? 'h-auto'
                                : 'h-52 overflow-auto',
                            items: isCreateEncounterAllowed
                              ? practitioner_options()
                              : [],
                            onClick: ({ key }) => {
                              if (isCreateEncounterAllowed) {
                                handleCreateEncounter(key);
                                setSelectedPractitioner(key);
                                setSearchFilters((prevFilters) => ({
                                  ...prevFilters,
                                  practitioner_id: key,
                                }));
                                setPageState({
                                  current: 1,
                                  pageSize:
                                    auraView === 'LIST'
                                      ? DEFAULT_PAGE_SIZE
                                      : 100,
                                });
                                changeEncounterStatus(record?.encounter_id);
                              } else {
                                setIsUpgradeModalVisible(true);
                              }
                            },
                          }}
                          rootClassName={`add-appointment-dropdown rounded-xl drop-shadow-sm flex ${
                            isCreateEncounterAllowed
                              ? 'is-primary'
                              : 'is-secondary'
                          }`}
                          onClick={() => {
                            if (isCreateEncounterAllowed) {
                              handleCreateEncounter(
                                currentPractitioner?.practitioner_id,
                                { is_pinned_encounter: true }
                              );
                              setSelectedPractitioner(
                                currentPractitioner?.practitioner_id
                              );
                              setSearchFilters((prevFilters) => ({
                                ...prevFilters,
                                practitioner_id:
                                  currentPractitioner?.practitioner_id,
                              }));
                              setPageState({
                                current: 1,
                                pageSize: DEFAULT_PAGE_SIZE,
                              });
                              changeEncounterStatus(record?.encounter_id);
                            } else {
                              setIsUpgradeModalVisible(true);
                            }
                          }}
                        >
                          <div
                            id="add_encounter"
                            className="flex past-encounter-div px-1 gap-1"
                            onClick={handleAddEncounterClick}
                          >
                            {isShowEncounterTooltip ? (
                              <Tooltip title="Add encounter" placement="top">
                                <span className="text-white text-2xl">+</span>
                              </Tooltip>
                            ) : (
                              <>
                                <PlusOutlined />
                                <span className="font-sans">Add encounter</span>
                              </>
                            )}
                          </div>
                        </Dropdown.Button>
                      </Tooltip>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </>
        //Desktop view ends here
      )}

      <ZoomAlert
        isBasicModalVisible={isBasicModalVisible}
        handleBasicModalOk={handleBasicModalOk}
        handleOpenInNewTab={handleOpenInNewTab}
      />
    </>
  );
};
